import React, { useState } from "react";
import "../../Styles/LocalLeadersForm.css";

const AdminLocalLeadersForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    alias: "",
    position: "",
    party: "",
    voterId: "",
    aadhaar: "",
    mobile: "",
    village: "",
    mandal: "",
    dateJoined: "",
    status: "",
    remarks: "",
    photo: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="ldrform-container">
      <div className="ldrform-card">
        <div className="ldrform-header">
          <h2>Add New Local Political Leader</h2>
          <p>Register a local political leader in your constituency</p>
          <button
            className="ldrform-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="ldrform-grid">

            <div className="ldrform-group">
              <label>Leader Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Name"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Alias / Known As</label>
              <input
                type="text"
                name="alias"
                placeholder="Ex: Ramesh Garu"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Position *</label>
              <input
                type="text"
                name="position"
                placeholder="Ex: Mandal President"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Party *</label>
              <input
                type="text"
                name="party"
                placeholder="Enter Party Name"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Voter ID *</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter Voter ID (EPIC No.)"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Aadhaar Number *</label>
              <input
                type="text"
                name="aadhaar"
                placeholder="Enter 12-digit Aadhaar Number"
                maxLength="12"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Mobile Number *</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="ldrform-group">
              <label>Date Joined *</label>
              <input
                type="date"
                name="dateJoined"
                onChange={handleChange}
              />
            </div>

            <div className="ldrform-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>

            <div className="ldrform-group">
              <label>Upload Photo *</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="ldrform-group ldrform-full-width">
            <label>Remarks</label>
            <textarea
              rows="4"
              name="remarks"
              placeholder="Enter Remarks"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="ldrform-btn-group">
            <button type="submit" className="ldrform-submit-btn">
              Submit
            </button>
            <button type="reset" className="ldrform-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLocalLeadersForm;